import CssBaseline from "Theme/overrides/CssBaseline";

const overrides = () => {
  return {
    ...CssBaseline(),
  };
};

export default overrides;
